import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { RouterGoParams, RouterStateModel } from './router.model';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { Navigate } from '@ngxs/router-plugin';

@Injectable({ providedIn: 'root' })
export class RouterFacade {
  currentUrl$ = this.store.select((state: object & { router: RouterStateModel }) => state.router.state.url);
  constructor(private store: Store, private route: ActivatedRoute, private location: Location) {}

  go({ path, queryParams, extras }: RouterGoParams): void {
    this.store.dispatch(new Navigate(path, queryParams, { ...extras, relativeTo: this.route }));
  }

  back(): void {
    this.location.back();
  }

  forward(): void {
    this.location.forward();
  }
}
